import React from 'react';
import VariableRow from './VariableRow';
import './variables-panel.css';

export default function VariablesPanel({ variableMap, onJump, style }) {
  const list = React.useMemo(() => {
    return Array.from(variableMap.values()).sort((a, b) => a.name.localeCompare(b.name));
  }, [variableMap]);

  return (
    <div className="variables-panel" style={style}>
      <h3 className="variables-title">Survey Variables</h3>
      <table className="variables-table">
        <thead>
          <tr>
            <th>Variable</th>
            <th>Defined At</th>
            <th>Used At</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          {list.map((rec) => (
            <VariableRow key={rec.name} rec={rec} onJump={onJump} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
